// @vendor
const React = require('react');
const PropTypes = require('prop-types');

// @ helpers
const { formatText } = require('core/i18n').i18n;

//@components
const ProductBannerHeader = require('components/commons/productBannerHeader/productBannerHeader');

const InsurancesStatusAlternativeWaffer = props => {

    const poeditorPrefix = 'insuranceLandingCC-insuranceLandingCC';
    const insuranceWaferSubTitle = formatText(`${poeditorPrefix}_insuranceOfferProcessMainText`);
    const insuranceWaferIcon = 'icon-house-rebrand';
    const messages = [
        {
            text: `${poeditorPrefix}_insuranceOfferProcessContactInfo`
        },
        {
            text: formatText(`${poeditorPrefix}_insuranceOfferProcessSecondaryText`)
        }
    ];

    const insuranceWaferTitle = {
        icon: 'icon-insurances-badge',
        text: formatText(`${poeditorPrefix}_insuranceOfferProcessTitle`)
    };

    const insuranceWaferButton = {
        text: formatText(`${poeditorPrefix}_insuranceOfferProcessContinueLink`),
        isOKButton: true,
        callback: () => {
            props.onContinue()
        }
    };

    const insuranceWaferCustomButton = {
        onAccept: () => {
            props.onCancel()
        },
        text: formatText(`${poeditorPrefix}_insuranceOfferProcessCancelLink`)
    };

    return (
        <div
            ref={props.innerRef}
            className="insurances-status-waffer-cc__container"
        >
            <ProductBannerHeader
                title={insuranceWaferTitle}
                image={insuranceWaferIcon}
                subtitle={insuranceWaferSubTitle}
                messages={messages}
                button={insuranceWaferButton}
                customButton={insuranceWaferCustomButton} />
        </div>
    );

}

InsurancesStatusAlternativeWaffer.propTypes = {
    innerRef: PropTypes.any,
    onCancel: PropTypes.func.isRequired,
    onContinue: PropTypes.func.isRequired,
};

InsurancesStatusAlternativeWaffer.defaultProps = {
    innerRef: () => { }
}

module.exports = InsurancesStatusAlternativeWaffer;
